module.exports = __webpack_public_path__ + "img/Hand_31_05_20.4c94ea9c.png";